import * as React from 'react';

const useImageLoaded = (ref)=>{
    const [loaded, setLoaded] = React.useState(false);
    const onLoad = ()=>{
        setLoaded(true);
    };
    React.useEffect(()=>{
        var ref1;
        if ((ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.complete) && ref.current.naturalWidth !== 0) {
            onLoad();
        }
    }, [
        ref
    ]);
    return [
        loaded,
        onLoad
    ];
};

export { useImageLoaded };
//# sourceMappingURL=use-image-loaded.js.map
